import type { LinkableIdentity, LinkIdentityResponse, UserStateResponse } from '../types';
import axiosInstance from './axiosInstance';

export const fetchUserState = async (getToken: () => Promise<string>): Promise<UserStateResponse> => {
  const token = await getToken();
  const response = await axiosInstance.get<UserStateResponse>('/user/state', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const acceptCurrentTerms = async (getToken: () => Promise<string>): Promise<void> => {
  const token = await getToken();
  await axiosInstance.post('/user/terms-acceptance', {}, { headers: { Authorization: `Bearer ${token}` } });
};

export const fetchLinkableIdentities = async (getToken: () => Promise<string>): Promise<LinkableIdentity[]> => {
  const token = await getToken();
  const response = await axiosInstance.get<LinkableIdentity[]>('/user/linkable-identities', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const linkIdentity = async (
  getToken: () => Promise<string>,
  action: 'link' | 'nolink',
  auth0Sub?: string,
): Promise<LinkIdentityResponse> => {
  const token = await getToken();

  const payload = action === 'link' && auth0Sub ? { action, auth0_sub: auth0Sub } : { action };

  const response = await axiosInstance.post<LinkIdentityResponse>('/user/link-identity', payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
